import React, { useState } from "react";
import {
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import MDButton from "../../../../../components/MDButton";
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDInput from "../../../../../components/MDInput";

const CheckoutForm = ({ clientSecret, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [cardholderName, setCardholderName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    if (!stripe || !elements) return;

    setLoading(true);
    setErrorMessage("");

    const cardElement = elements.getElement(CardElement);

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: cardholderName,
        },
      },
    });

    if (result.error) {
      setErrorMessage(result.error.message);
      setLoading(false);
    } else if (result.paymentIntent.status === "succeeded") {
      setLoading(false);
      onSuccess();
    }
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      gap={3}
      p={4}
      width="100%"
    >
      {/* Title */}
      <MDTypography variant="h5" fontWeight="bold">
        Complete Your Payment
      </MDTypography>

      {/* Cardholder Name */}
      <MDBox>
        <MDTypography variant="button" fontWeight="medium" mb={1}>
          Cardholder Name
        </MDTypography>
        <MDInput
          fullWidth
          placeholder="Enter name on card"
          value={cardholderName}
          onChange={(e) => setCardholderName(e.target.value)}
        />
      </MDBox>

      {/* Card Element */}
      <MDBox>
        <MDTypography variant="button" fontWeight="medium" mb={1}>
          Card Details
        </MDTypography>

        <MDBox
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            padding: "14px",
            backgroundColor: "#fff",
          }}
        >
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  fontSize: "16px",
                  color: "#1a1f36",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#e5424d",
                },
              },
            }}
          />
        </MDBox>
      </MDBox>

      {/* Error Message */}
      {errorMessage && (
        <MDTypography variant="caption" color="error">
          {errorMessage}
        </MDTypography>
      )}

      {/* Pay Button */}
      <MDButton
        variant="contained"
        color="success"
        fullWidth
        disabled={loading || !cardholderName}
        onClick={handleSubmit}
        sx={{ height: "48px" }}
      >
        {loading ? "Processing..." : "Pay Now"}
      </MDButton>
    </MDBox>
  );
};

export default CheckoutForm;
